import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import Footer from './components/Footer';
import {
  PrivacyPolicy,
  TermsOfService,
  SecurityPolicy,
  AutoPayments,
  Tariffs,
  DynamicLanding,
  NotFound,
} from './pages';
import { getSiteName } from './utils/theme';

const HomePage = () => (
  <>
    <Hero />
    <Features />
    <Pricing />
    <HowItWorks />
  </>
);

function App() {
  useEffect(() => {
    document.title = getSiteName();
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-lunar-gradient">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/security-policy" element={<SecurityPolicy />} />
          <Route path="/auto-payments" element={<AutoPayments />} />
          <Route path="/tariffs" element={<Tariffs />} />
          {/* Динамические лендинги по slug. DynamicLanding сам показывает NotFound, если slug не найден. */}
          <Route path="/:slug" element={<DynamicLanding />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
